module.exports = __webpack_public_path__ + "img/shizuha aki_sc2.72f42cb5.png";